<body class="ltr main-body leftmenu">
  <form autocomplete="off" novalidate>
    <div class="main-content side-content pt-0 ml-0">
      <div class="main-container container-fluid">
        <div class="inner-body">
          <div class="row row-sm">
            <div class="col-lg-12">
              <div class="card custom-card">
                <div class="card-body pb-0">
                  <div class="row">
                    <div class="col-md-7">
                      <div class=" d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>
                              {{'header.course-data.titleList.Course'
                              | translate }}
                            </b></h3>
                          <p class="text-muted card-sub-title mb-0">
                            List Of Courses
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3" [formGroup]="CourseSearchForm">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>{{'header.course-data.titleList.Search' | translate}}
                        </mat-label> <input class="color" matInput placeholder="Search" (keyup)="keypress()"
                          formControlName="SearchString">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>
                    <div class="col-md-1 prpl">
                      <button id="New" type="button" class="btn btn-primary btn-icon-text  mt-1"
                        (click)="addnewrecord()">
                        <span style="display: flex; align-items: center;">
                          <img width="20vh" src="../../assets/img/plus.gif" style="margin-right: 5px;">
                          {{ 'header.course-data.titleList.AddNewRecord' | translate }}
                        </span>
                      </button>
                    </div>
                    <div class="col-md-1 prpl1">
                      <button id="Print" type="button" class="btn sz btn-primary btn-icon-text floatright mt-1 fr" (click)="Print()">
                          <span style="display: contents; align-items: center;">
                              <img width="20vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
                              {{ 'header.course-data.titleList.Print' | translate }}
                          </span>
                      </button>
                  </div>
                  </div>
                  <hr class="mt-2">
                  <div class="table-responsive table-container">
                    <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                      <thead>
                        <tr>

                          <th class="f600">
                            {{'header.course-data.table.ProgramCode' | translate }}

                          </th>
                          <th class="f600">
                            {{'header.course-data.table.ProgramName' | translate }}
                          </th>
                          <th class="f600">
                            {{'header.course-data.table.Faculty' | translate }}
                          </th>
                          <th class="f600">
                            {{'header.course-data.table.NoOfYears' | translate }}
                          </th>
                          <th class="f600 text-center">{{'header.course-data.table.Action' |
                            translate }}</th>
                        </tr>
                      </thead>
                      <tbody id="table_data">
                        <tr *ngFor="let exam of courseList;">

                          <td> {{exam.CoCode}} </td>
                          <td>{{exam.CoName}}</td>
                          <td> {{exam.CoFcCode}} </td>
                          <td> {{exam.CoYears}}</td>
                          <td class="text-center"> <a class="floating mr-2 pr-3" title="Edit" (click)="editData(exam)">
                              <i class="fa fa-edit "></i> </a> <a class=" ml-2 floating" title="Delete"
                              (click)="deleteData(exam)"> <i class="fas fa-trash"></i> </a> </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                    (page)="onPageChange($event)"></mat-paginator>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</body>